import LogoS from '../../../assets/images/logo-s.png';
import './index.scss';

const Logo = () => (
  <div className="logo-container">
    <img
      className="solid-logo"
      src={LogoS}
      alt="JavaScript,  Developer"
    />
  </div>
);

export default Logo;
